import {signal, WritableSignal} from '@angular/core';

export const isSpecialOfferSignal: WritableSignal<boolean> = signal<boolean>(false);
